import React from 'react';
import { Calendar } from 'lucide-react';

interface DateRangePickerProps {
  startDate: string;
  endDate: string;
  onChange: (range: { start: string; end: string }) => void;
}

export const DateRangePicker: React.FC<DateRangePickerProps> = ({
  startDate,
  endDate,
  onChange,
}) => {
  const handleStartDateChange = (date: string) => {
    onChange({ start: date, end: endDate });
  };

  const handleEndDateChange = (date: string) => {
    onChange({ start: startDate, end: date });
  };

  const setQuickRange = (days: number) => {
    const end = new Date().toISOString().split('T')[0];
    const start = new Date(Date.now() - days * 24 * 60 * 60 * 1000).toISOString().split('T')[0];
    onChange({ start, end });
  };

  return (
    <div className="flex items-center space-x-2">
      <Calendar className="w-4 h-4 text-gray-400" />
      
      <div className="flex items-center space-x-2">
        <input
          type="date"
          value={startDate}
          onChange={(e) => handleStartDateChange(e.target.value)}
          className="text-sm border border-gray-300 rounded px-2 py-1"
        />
        <span className="text-sm text-gray-500">to</span>
        <input
          type="date"
          value={endDate}
          onChange={(e) => handleEndDateChange(e.target.value)}
          className="text-sm border border-gray-300 rounded px-2 py-1"
        />
      </div>

      <div className="flex space-x-1">
        <button
          onClick={() => setQuickRange(1)}
          className="px-2 py-1 text-xs bg-gray-100 hover:bg-gray-200 rounded transition-colors"
        >
          Today
        </button>
        <button
          onClick={() => setQuickRange(7)}
          className="px-2 py-1 text-xs bg-gray-100 hover:bg-gray-200 rounded transition-colors"
        >
          7 days
        </button>
        <button
          onClick={() => setQuickRange(30)}
          className="px-2 py-1 text-xs bg-gray-100 hover:bg-gray-200 rounded transition-colors"
        >
          30 days
        </button>
      </div>
    </div>
  );
};